import { useNavigate, useParams } from "react-router-dom";
import Add from "../../../../components/atoms/icons/general/add/Add";
import Bracket from "../../../../components/atoms/icons/general/bracket/Bracket";
import Download from "../../../../components/atoms/icons/general/download/Download";
import FilledButton from "../../../../components/molecules/buttons/filledButton/FilledButton";
import Searchbar from "../../../../components/molecules/searchbar/Searchbar";
import "./CrmViewer.css";
import React, { useContext, useEffect, useState } from "react";
import {
  getClientTabColumnClassName,
  ClientTabSearchPlaceholder,
  ClientTabColumns,
  getClientSortingFilters,
  AgencyClientTabSearchPlaceholder,
  getClientColumnContent,
} from "./subTabs/CrmClientTabComponents";
import Checkbox from "../../../../components/molecules/formComponents/checkbox/Checkbox";
import { Link } from "react-router-dom";
import { createDownloadLink, formatNumberWithSpaces, stringToDate } from "../../../../utils/Utils";
import AppContext from "../../../../context/AppContext";
import Copy from "../../../../components/atoms/icons/account/copy/Copy";
import ArrowSm from "../../../../components/atoms/icons/general/arrowSm/ArrowSm";
import CrmNotesContainer from "../../../../components/crmComponents/client/crmNotesContainer/CrmNotesContainer";
import { useWindowSize } from "@uidotdev/usehooks";
import { useCrm } from "../../../../context/CrmContext";
import Loader from "../../../../components/organisms/loader/Loader";
import CrmSortingTab from "../../../../components/crmComponents/crmSortingTab/CrmSortingTab";
import CreateUserModal from "../../../../components/forms/modals/crm/createUserModal/CreateUserModal";
import { useForm } from "react-hook-form";
import { useResources } from "../../../../context/ResourcesContext";
import {
  exportAgencyEstimationsApi,
  exportAgencyUsersApi,
  fetchAllAgencyEstimationsApi,
  fetchAllAgencyMembersApi,
} from "../../../../api/crm/AgencyApi";
import {
  EstimationsTabSearchPlaceholder,
  getEstimationsSortingFilters,
  getEstimationsTabColumnClassName,
} from "./subTabs/CrmEstimationsTabComponents";
import {
  EstimationTableColumns,
  getEstimationColumnContent,
} from "../../../../components/organisms/resourcesComponents/EstimationsComponents";
import { fetchAllActivitesByIdApi } from "../../../../api/ParcoursApi";
import {
  createClientNoteApi,
  exportUsersApi,
  fetchAllClientsApi,
  fetchClientNotesApi,
} from "../../../../api/crm/CrmClientsApi";
import ProgressCircle from "../../../../components/atoms/progressCircle/ProgressCircle";
import Check from "../../../../components/atoms/icons/general/check/Check";
import Unarchive from "../../../../components/atoms/icons/account/unarchive/Unarchive";
import Archive from "../../../../components/atoms/icons/account/archive/Archive";
import Building from "../../../../components/atoms/icons/header/building/Building";
import Factory from "../../../../components/atoms/icons/header/factory/Factory";
import Shop from "../../../../components/atoms/icons/header/shop/Shop";
import UnfilledButton from "../../../../components/molecules/buttons/unfilledButton/UnfilledButton";
import {
  exportNetworkEstimationsApi,
  exportNetworkUsersApi,
  fetchAllNetworkEstimationsApi,
  fetchAllNetworkMembersApi,
} from "../../../../api/crm/NetworkApi";
import { exportEstimationsApi, fetchAllEstimationsApi } from "../../../../api/crm/CrmEstimationsApi";

function CrmViewer({ isNetwork, isAgency }) {
  const { register, unregister, setValue, getValues, watch } = useForm();
  const inputForm = { register, unregister, setValue };

  const { createNotification, setModalVisible, setModalContent } = useContext(AppContext);
  const { formatTableColumns, copyUuidToClipboard, formatEstimation } = useResources();
  const { getClientPaymentStatus, partnersList, subscriptionsList, rolesList } = useCrm();

  const { tabParam, agencyParam, networkParam } = useParams();
  const { width } = useWindowSize();
  const navigate = useNavigate();

  const [isLoaderVisible, setIsLoaderVisible] = useState(true);
  const [isExportButtonLoading, setIsExportButtonLoading] = useState(false);

  const [searchValue, setSearchValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [searchPlaceholder, setSearchPlaceholder] = useState("");
  const [resetSerchValueTrigger, setResetSerchValueTrigger] = useState(false);
  const [queryParams, setQueryParams] = useState({
    limit: 50,
    hits: 0,
    matchs: 0,
    totalHits: 0,
  });

  const [items, setItems] = useState([]);
  const [tabColumns, setTabColumns] = useState([]);
  const [sortingFilters, setSortingFilters] = useState([]);

  // Estimations
  const [activities, setActivities] = useState([]);

  const networkAllowedClientsColumns = [
    "email",
    "name",
    "partner_name",
    "agency_name",
    "tel",
    "nb_estimations",
    "subscription_name",
    "payment_status",
  ];

  const orderByEstimationsMap = {
    name: "infos.enseigne",
    date_creation: "date_creation_estimation",
    date_last_update: "date_last_update_estimation",
    raison_sociale: "infos.raison_sociale",
    activite: "infos.activite.description",
    type: "type.description",
    address: "infos.rue",
    code_postal: "infos.code_postal",
    activite: "infos.activite.description",
  };

  const tabComponents = {
    searchPlaceholder: {
      utilisateurs: isNetwork || isAgency ? AgencyClientTabSearchPlaceholder : ClientTabSearchPlaceholder,
      estimations: EstimationsTabSearchPlaceholder,
    },
    columns: { utilisateurs: ClientTabColumns, estimations: EstimationTableColumns },
    getColumnClassName: { utilisateurs: getClientTabColumnClassName, estimations: getEstimationsTabColumnClassName },
    getColumnContent: { utilisateurs: getClientColumnContent, estimations: getEstimationColumnContent },
  };

  useEffect(() => {
    fetchActivities();
  }, []);

  useEffect(() => {
    setSearchPlaceholder(tabComponents.searchPlaceholder[tabParam]);
    setResetSerchValueTrigger(resetSerchValueTrigger => !resetSerchValueTrigger);
    setupTabColumns(tabComponents.columns[tabParam], width, isNetwork || isAgency);
  }, [tabParam, width, isNetwork, isAgency]);

  useEffect(() => {
    fillSortingFilters(tabParam, subscriptionsList, rolesList);
  }, [tabParam, partnersList, subscriptionsList, rolesList, isNetwork, isAgency, activities]);

  useEffect(() => {
    const timeout = setTimeout(
      () => fetchItems(tabParam, { limit: queryParams.limit, search: searchValue, ...queryParams.appliedFilters }),
      500,
    );

    return () => clearTimeout(timeout);
  }, [searchValue, isNetwork, isAgency, networkParam, agencyParam]);

  // Clients functions

  async function fetchClients(params) {
    let result = [];

    try {
      let res = [];
      if (isNetwork) res = (await fetchAllNetworkMembersApi(networkParam, params)).data;
      else if (isAgency) res = (await fetchAllAgencyMembersApi(agencyParam, params)).data;
      else res = (await fetchAllClientsApi(params)).data;

      result = res.users.map(client => ({
        ...client,
        name: client.last_name + " " + client.first_name,
        address: client.street + " " + client.city,
        partner_name: client.partner_name || "-",
        subscription_name: client.subscriptions?.current?.plan?.toUpperCase() || "-",
        date_start_subscription: client.subscriptions?.current.date_start_sub?.slice(0, 16) || "-",
        date_end_subscription: client.subscriptions?.current.date_end_sub?.slice(0, 16) || "-",
        date_last_connexion: client.date_last_connexion?.slice(0, 16) || "-",
        date_creation: client.date_creation?.slice(0, 16) || "-",
        payment_status: getClientPaymentStatus(client.subscriptions),
        status: client.is_active ? "Actif" : "Non confirmé",
      }));

      updateQueryParams(res);
    } catch (error) {
      createNotification(
        <>Une erreur est survenue lors de la récupération des utilisateurs. Veuillez réessayer.</>,
        "var(--red)",
        "var(--dark-blue)",
      );
    } finally {
      return result;
    }
  }

  async function showNotesModal(e, notes, clientUuid, createNote) {
    e.stopPropagation();
    e.preventDefault();

    if (createNote) notes = [(await createClientNoteApi(clientUuid)).data];

    setModalContent({
      title: "Notes",
      content: (
        <>
          <CrmNotesContainer notes={notes} clientUuid={clientUuid} updateNotesTrigger={updateClientNotes} />
          <div className='modal-buttons-row'>
            <FilledButton onClick={() => setModalVisible()}>OK</FilledButton>
          </div>
        </>
      ),
      className: "big-modal",
    });

    setModalVisible(true);
  }

  async function updateClientNotes(clientUuid) {
    try {
      const res = (await fetchClientNotesApi(clientUuid)).data;
      setItems(items => [...items.map(item => (item.uuid === clientUuid ? { ...item, notes: [...res] } : item))]);

      setModalContent({
        title: "Notes",
        content: (
          <>
            <CrmNotesContainer notes={res} clientUuid={clientUuid} updateNotesTrigger={updateClientNotes} />
            <div className='modal-buttons-row'>
              <FilledButton onClick={() => setModalVisible()}>OK</FilledButton>
            </div>
          </>
        ),
        className: "big-modal",
      });
    } catch (error) {
      createNotification(
        <>Une erreur est survenue lors de la mise à jour des notes. Veuillez réessayer.</>,
        "var(--red)",
        "var(--dark-blue)",
      );
    }
  }

  function showCreateClientModal() {
    setModalContent({
      title: "Créer un utilisateur",
      content: (
        <CreateUserModal
          rolesList={rolesList}
          partnersList={partnersList}
          triggerUpdate={() =>
            fetchItems(tabParam, { limit: queryParams.limit, search: searchValue, ...queryParams.appliedFilters })
          }
        />
      ),
      className: "big-modal",
    });

    setModalVisible(true);
  }

  // Estimations functions

  async function fetchEstimations(params) {
    let result = [];
    if (isAgency) return navigate("/403");
    try {
      let res = [];
      if (isNetwork) res = (await fetchAllNetworkEstimationsApi(networkParam, params)).data;
      else if (isAgency) res = (await fetchAllAgencyEstimationsApi(agencyParam, params)).data;
      else res = (await fetchAllEstimationsApi(params)).data;

      result = res.estimations.map(estimation => formatEstimation(estimation));
      updateQueryParams(res);
    } catch (error) {
      createNotification(
        <>Une erreur est survenue lors de la récupération des estimations. Veuillez réessayer.</>,
        "var(--red)",
        "var(--dark-blue)",
      );
    } finally {
      return result;
    }
  }

  async function fetchActivities() {
    try {
      const res = (await fetchAllActivitesByIdApi()).data;
      setActivities(res.sort((a, b) => a.description.localeCompare(b.description)));
    } catch (error) {
      createNotification(
        <>Une erreur est survenue lors de la récupération des activités. Veuillez réessayer.</>,
        "var(--red)",
        "var(--dark-blue)",
      );
    }
  }

  // Fetching functions

  async function fetchItems(tabParam, params) {
    setIsLoading(true);

    switch (tabParam) {
      case "utilisateurs":
        setItems(await fetchClients(params));
        break;
      case "estimations":
        setItems(await fetchEstimations(params));
    }

    setTimeout(() => {
      setIsLoaderVisible(false);
      setIsLoading(false);
    }, 200);
  }

  // Common functions

  function updateQueryParams(res) {
    let orderBy = res.order_by;

    if (tabParam === "estimations")
      Object.keys(orderByEstimationsMap).forEach(key => {
        if (orderByEstimationsMap[key] === orderBy) {
          orderBy = key;
          return;
        }
      });

    setQueryParams({
      limit: res.limit,
      hits: res.hits,
      matchs: res.matchs,
      totalHits: res.total_hits,
      appliedFilters: res.applied_filters,
      orderBy: orderBy,
      orderDir: res.order_dir,
    });
  }

  function setupTabColumns(columns, width, isNetwork) {
    if (tabParam === "estimations") {
      columns = [
        ...columns.slice(0, 3),
        { id: 20, label: "Propriétaire", key: "email", default: 992, showBracket: true },
        ...columns.slice(3),
      ];
    }

    if (isNetwork) {
      const index = columns.findIndex(value => value.key === "agency_name");
      if (index > -1) columns[index].default = 1200;
    }

    let formattedTabColumns = formatTableColumns(columns, width);

    if (isNetwork && tabParam === "utilisateurs")
      formattedTabColumns = formattedTabColumns.filter(column => networkAllowedClientsColumns.includes(column.key));

    setTabColumns(formattedTabColumns);
  }

  function getRowLink(item) {
    switch (tabParam) {
      case "utilisateurs":
        return isNetwork || isAgency ? "" : `/admin/crm/${tabParam}/${item?.uuid}`;
      case "estimations":
        return "/synthese/" + item?.uuid;
    }
  }

  async function fillSortingFilters(tabParam) {
    let result;

    switch (tabParam) {
      case "utilisateurs":
        result = await getClientSortingFilters(partnersList, subscriptionsList, rolesList);
        break;
      case "estimations":
        result = await getEstimationsSortingFilters(activities);
    }

    setSortingFilters(result.filter(filter => (isNetwork && filter.visibleForNetworks) || !isNetwork));
  }

  function displayMoreItems(newLimit) {
    fetchItems(tabParam, { limit: newLimit, search: searchValue, ...queryParams.appliedFilters });
  }

  function resetFilters() {
    setTabColumns(formatTableColumns(tabComponents.columns[tabParam], width));
    setResetSerchValueTrigger(resetSerchValueTrigger => !resetSerchValueTrigger);

    fetchItems(tabParam, { limit: 50 });
  }

  function toggleAllCheckboxes() {
    const shouldCheck = !getValues("checkbox-all");

    Object.keys(getValues("checkbox-column")).forEach(key => setValue("checkbox-column." + key, shouldCheck));
  }

  function toggleColumnBracket(columnKey) {
    let result;

    if (queryParams.orderBy === columnKey)
      switch (queryParams.orderDir) {
        case "asc":
          result = { key: columnKey, order: "desc" };
          break;
        case "desc":
          result = null;
          break;
      }
    else result = { key: columnKey, order: "asc" };

    if (tabParam === "estimations" && orderByEstimationsMap[columnKey]) columnKey = orderByEstimationsMap[columnKey];

    fetchItems(tabParam, {
      limit: queryParams.limit,
      search: searchValue,
      ...queryParams.appliedFilters,
      ...(result ? { order_by: columnKey, order_dir: result.order } : {}),
    });
  }

  function applySortingFilters(values) {
    setTabColumns(values.tabColumns);

    let filters = {};
    values.filters.forEach(filter => {
      filter.options = filter.options.filter(option => option.id !== "undefined");
      if (filter.options.length) filters[filter.key] = filter.options.map(option => option.id).join(",");
    });

    fetchItems(tabParam, { limit: values.resultsLimit, search: searchValue, ...filters });
  }

  function exportItems(selectionOnly) {
    setIsExportButtonLoading(true);

    const checkedItemsUuids = [];

    if (selectionOnly) {
      const checkedItems = getValues("checkbox-column");

      items.forEach(item => {
        if (checkedItems[item.uuid]) checkedItemsUuids.push(item.uuid);
      });
    }
    // const exportedColumns = tabColumns.filter(column => column.visible).map(column => column.key);

    switch (tabParam) {
      case "utilisateurs":
        return exportUsers(checkedItemsUuids);
      case "estimations":
        return exportEstimations(checkedItemsUuids);
    }
  }

  async function exportUsers(usersUuids) {
    try {
      let res;
      if (isNetwork && networkParam) {
        res = (await exportNetworkUsersApi(networkParam, usersUuids)).data;
      } else if (isNetwork && agencyParam) {
        res = (await exportAgencyUsersApi(agencyParam, usersUuids)).data;
      } else {
        res = (await exportUsersApi(usersUuids)).data;
      }

      const link = createDownloadLink(res);

      if (!link) throw new Error();

      link.click();
      link.remove();
    } catch (error) {
      createNotification(
        <>Une erreur est survenue lors de l'export des utilisateurs. Veuillez réessayer.</>,
        "var(--red)",
        "var(--dark-blue)",
      );
    } finally {
      setIsExportButtonLoading(false);
    }
  }

  async function exportEstimations(estimationsUuids) {
    try {
      let res;
      if (isNetwork && networkParam) {
        res = (await exportNetworkEstimationsApi(networkParam, estimationsUuids)).data;
      } else if (isNetwork && agencyParam) {
        res = (await exportAgencyEstimationsApi(agencyParam, estimationsUuids)).data;
      } else {
        res = (await exportEstimationsApi(estimationsUuids)).data;
      }

      const link = createDownloadLink(res);

      if (!link) throw new Error();

      link.click();
      link.remove();
    } catch (error) {
      createNotification(
        <>Une erreur est survenue lors de l'export des estimations. Veuillez réessayer.</>,
        "var(--red)",
        "var(--dark-blue)",
      );
    } finally {
      setIsExportButtonLoading(false);
    }
  }

  function isExportSelectionButtonDisabled(checkboxColumns) {
    if (!checkboxColumns) return true;
    return !Object.values(checkboxColumns)?.some(Boolean);
  }

  return (
    <>
      <CrmSortingTab
        filters={sortingFilters}
        applySortingFilters={applySortingFilters}
        tabColumns={tabColumns}
        resultsLimit={queryParams.limit}
        triggerFiltersReset={resetFilters}
      />
      <div className='container'>
        {tabParam === "utilisateurs" || tabParam === "estimations" ? (
          <div className='crm-items-container'>
            <Loader visible={isLoaderVisible} className='crm-loader' preventScrolling={false} />
            <div className='crm-action-row'>
              <Searchbar
                className='crm-searchbar'
                placeholder={searchPlaceholder}
                onChange={value => setSearchValue(value)}
                resetValueTrigger={resetSerchValueTrigger}
              />
              <div className='crm-export-buttons-container'>
                <div className='crm-export-buttons'>
                  <FilledButton isLoading={isExportButtonLoading} onClick={() => exportItems()}>
                    Tout exporter
                  </FilledButton>
                  <FilledButton
                    isLoading={isExportButtonLoading}
                    disabled={isExportSelectionButtonDisabled(watch("checkbox-column"))}
                    onClick={() => exportItems(true)}>
                    Exporter la sélection
                  </FilledButton>
                </div>
                <UnfilledButton>
                  <Download color='var(--blue)' width='20px' />
                  Exporter
                </UnfilledButton>
              </div>
              {!isNetwork && tabParam === "utilisateurs" && (
                <FilledButton onClick={showCreateClientModal}>
                  <Add width='20px' /> Créer un utilisateur
                </FilledButton>
              )}
            </div>
            <div className='crm-table-container'>
              <div className='crm-thead'>
                <Checkbox
                  useForm={inputForm}
                  name='checkbox-all'
                  onChange={toggleAllCheckboxes}
                  className='crm-checkbox  crm-clickable-column'
                />
                {tabColumns?.map(
                  column =>
                    column.visible && (
                      <div
                        className={`crm-column-${column.key} ${column.showBracket ? "cursor-pointer" : ""}`}
                        {...(column.showBracket && { onClick: () => toggleColumnBracket(column.key) })}
                        key={column.id}>
                        {column.label}
                        {column.showBracket && (
                          <Bracket
                            rotation={
                              queryParams?.orderBy == column.key
                                ? queryParams?.orderDir === "asc"
                                  ? "180deg"
                                  : "0deg"
                                : "90deg"
                            }
                            width='12px'
                            className='ml-xs'
                            color='var(--blue)'
                          />
                        )}
                      </div>
                    ),
                )}
              </div>
              <div className='crm-tbody'>
                {items.map(item => (
                  <Link
                    className='crm-table-row'
                    key={item.uuid}
                    to={getRowLink(item)}
                    target={tabParam === "estimations" ? "_blank" : ""}>
                    <Checkbox
                      useForm={inputForm}
                      className='crm-checkbox crm-clickable-column'
                      name={"checkbox-column." + item.uuid}
                      onClick={e => e.stopPropagation()}
                    />
                    {tabColumns?.map(column => {
                      if (!column.visible) return null;
                      switch (column.key) {
                        case "uuid":
                          return (
                            <div
                              key={column.id}
                              className='crm-row-column crm-column-uuid crm-clickable-column'
                              onClick={e => copyUuidToClipboard(e, item.uuid)}>
                              <Copy
                                width='18px'
                                color='var(--white)'
                                onClick={e => copyUuidToClipboard(e, item.uuid)}
                              />
                            </div>
                          );
                        case "type":
                          return (
                            <div
                              title={item.type?.description.split(" ")[0]}
                              className={`crm-row-column crm-tag crm-column-${column.key} crm-${tabComponents.getColumnClassName[tabParam](column.key, item[column.key])}`}
                              key={column.id}>
                              {item.type?.id === 1 ? (
                                <Shop width='20px' color='var(--sky-blue-alt)' className='mr-sm' />
                              ) : item.type?.id === 2 ? (
                                <Factory width='20px' color='var(--grey-alt' className='mr-sm' />
                              ) : (
                                <Building width='20px' color='var(--light-gold)' className='mr-sm' />
                              )}
                              {item.type?.description.split(" ")[0]}
                            </div>
                          );
                        case "archived":
                          return (
                            <div className={`crm-row-column crm-tag crm-column-archive`} key={column.id}>
                              {item.archived ? (
                                <Unarchive width='20px' color='var(--red)' />
                              ) : (
                                <Archive width='20px' color='var(--green)' />
                              )}
                            </div>
                          );
                        case "validated":
                          return item.steps_status?.completed_steps === item.steps_status?.total_steps ? (
                            <div
                              className={`crm-row-column crm-column-archive crm-estimation-validated ${item.is_downloadable ? "" : "grey"}`}
                              key={column.id}>
                              <Check width='11px' color='var(--white)' />
                            </div>
                          ) : (
                            <ProgressCircle
                              key={column.id}
                              className='crm-row-column crm-tag crm-clickable-columncrm-column-archive'
                              totalSteps={item.steps_status?.total_steps}
                              currentStep={item.steps_status?.completed_steps}
                            />
                          );
                        case "notes":
                          return (
                            <div className='crm-row-column crm-column-notes' key={column.id}>
                              {item?.notes?.length ? (
                                <FilledButton
                                  color='var(--dark-blue)'
                                  bgColor='var(--sky-blue)'
                                  padding='1px 5px'
                                  fontSize='0.8rem'
                                  borderRadius='4px'
                                  onClick={e => showNotesModal(e, item.notes, item.uuid)}
                                  className='crm-row-button'>
                                  Afficher
                                </FilledButton>
                              ) : (
                                <FilledButton
                                  color='var(--dark-blue)'
                                  bgColor='var(--light-blue)'
                                  padding='1px 5px'
                                  fontSize='0.8rem'
                                  borderRadius='4px'
                                  onClick={e => showNotesModal(e, item.notes, item.uuid, true)}
                                  className='crm-row-button'>
                                  Ajouter
                                </FilledButton>
                              )}
                            </div>
                          );
                        default:
                          return (
                            <div
                              title={item[column.key]}
                              className={`crm-row-column crm-column-${column.key} crm-${tabComponents.getColumnClassName[tabParam](column.key, item[column.key])}`}
                              key={column.id}>
                              {tabComponents.getColumnContent[tabParam](column.key, item)}
                            </div>
                          );
                      }
                    })}
                  </Link>
                ))}
              </div>
              <div className='crm-paginator'>
                {queryParams.hits} résultats affichés sur {formatNumberWithSpaces(queryParams.totalHits, 1)}.{" "}
                {queryParams.hits < queryParams.totalHits && (
                  <span onClick={() => displayMoreItems(Number(queryParams.limit) + 50)}>Afficher plus</span>
                )}
                {isLoading && <div className='button-loader crm-small-loader' />}
              </div>
            </div>
          </div>
        ) : (
          <h2 className='centered text-xl'>Pas encore développé</h2>
        )}
      </div>
    </>
  );
}

export default CrmViewer;
